import { ExperimentAttributesProvider } from '@vivino/js-web-common';
import { Highlight, Price, ValueForMoneyScoresFull } from '@webtypes/goApi';
import {
  RubyLibCartFull,
  RubyLibExploreVintagesPriceRange,
  RubyLibFullRegion,
  RubyLibFullVintage,
  RubyLibFullWine,
  RubyLibMerchant,
  RubyLibMerchantCheckoutPricesAndAvailability,
} from '@webtypes/rubyLibApi';
import React from 'react';
import {
  CART_ITEM_SOURCE_TYPES,
  CartItemSourceContext,
} from 'vivino-js/context/CartItemSourceContext';
import { CartsProvider } from 'vivino-js/context/CartsContext';

import BestPickBanner from 'vivino-js/components/BestPickBanner';
import PurchaseAvailabilityList from 'vivino-ui/components/PurchaseAvailability/PurchaseAvailabilityList.container';

interface pagageInformationType {
  deal?: boolean;
  carts?: RubyLibCartFull[];
  full_region?: RubyLibFullRegion;
  highlights?: Highlight[];
  is_deal: boolean;
  merchant?: RubyLibMerchant;
  price?: Price | any;
  vintage: RubyLibFullVintage;
  wine: RubyLibFullWine;
  sold_out?: boolean;
  is_deal_page?: boolean;
  value_for_money?: ValueForMoneyScoresFull;
  found_by_merchant_and_sku?: boolean;
  price_range?: RubyLibExploreVintagesPriceRange;
  prices_and_availability?: RubyLibMerchantCheckoutPricesAndAvailability;
  prices_and_availabilities?: RubyLibMerchantCheckoutPricesAndAvailability[];
}

interface Props {
  stateCode: string;
  countryCode: string;
  winePageType: string;
  pageInformation: pagageInformationType;
}

export default ({ pageInformation, countryCode, stateCode }: Props) => {
  const price = pageInformation?.price;
  const vintage = pageInformation?.vintage;
  const priceAndAvailability = pageInformation?.prices_and_availability;
  const pricesAndAvailabilities = pageInformation?.prices_and_availabilities;
  const merchantsWithPrices = priceAndAvailability?.merchants_with_prices;
  const isVintageSubstitutionDisabled = pageInformation?.found_by_merchant_and_sku;

  return (
    <CartsProvider>
      <CartItemSourceContext.Provider value={CART_ITEM_SOURCE_TYPES.WINE_PAGE_ROOT}>
        <ExperimentAttributesProvider>
          <>
            {price?.deal && <BestPickBanner price={price} />}
            <PurchaseAvailabilityList
              vintage={vintage}
              stateCode={stateCode}
              countryCode={countryCode}
              wineId={vintage?.wine?.id}
              isDeal={pageInformation?.is_deal_page}
              merchantsWithPrices={merchantsWithPrices}
              priceAndAvailability={priceAndAvailability}
              valueForMoney={pageInformation?.value_for_money}
              checkoutPricesAndAvailabilities={pricesAndAvailabilities}
              isVintageSubstitutionDisabled={isVintageSubstitutionDisabled}
            />
          </>
        </ExperimentAttributesProvider>
      </CartItemSourceContext.Provider>
    </CartsProvider>
  );
};
